import { RowNode } from 'ag-grid-community';
import { Geometry } from 'ol/geom';
import VectorSource from 'ol/source/Vector';
import { FEATURE_SELECTED } from './components/PlanningRoutesMap/utils/handleSelect';
import TranslationHelper from '../../helpers/TranslationHelper';
import { Feature } from 'ol';
import olMap from 'ol/Map';
import {
    fitMap,
    LARGE_MAP_PADDING,
} from '../discovery/components/DiscoveryMap/_utils';
import { MAX_ZOOM } from '../../constants/map/zoom';
import { IRoute } from '../../state/ui/planning/routes';
import { UNASSIGNED_ID } from '../../state/ui/planning/tasks/utils/isUnassigned';
import { isEmpty } from 'ol/extent';

export const getRouteAssigned = (route: IRoute | null) => {
    return route?.id !== undefined ? route.id !== UNASSIGNED_ID : null;
};
export const countNodesByRouteName = (
    nodes: RowNode[]
): { tasksList: { routeName: string; count: number }[]; ids: number[] } => {
    const countsArray = nodes.reduce((acc, node) => {
        const routeName =
            node.data.routeName || TranslationHelper.translate('Unassigned');
        const existingEntry = acc.find(
            (entry) => entry.routeName === routeName
        );

        if (existingEntry) {
            existingEntry.count += 1;
        } else {
            acc.push({ routeName, count: 1 });
        }

        return acc;
    }, [] as { routeName: string; count: number }[]);

    const ids = nodes.map((node) => node.data.id);

    return { tasksList: countsArray, ids };
};

export const handleSelectFeaturesOnMap = (
    source: VectorSource<Geometry>,
    items: string[]
) => {
    const itemSet = new Set(items);

    const features = source.getFeatures();
    features.forEach((feature) => {
        const data = feature?.get('data');
        const id = data?.id;

        // Unset 'selected' for all features first
        feature.unset('selected');

        // Set 'selected' if the feature's id is in the itemSet
        if (id && itemSet.has(id)) {
            feature.set('selected', FEATURE_SELECTED);
        }
    });
};

export const onFeatureSelected = (
    source: VectorSource<Geometry> | null,
    items: number[],
    map: olMap | null
) => {
    if (!source) return;
    const itemSet = new Set(items);
    const features = source.getFeatures();
    features.forEach((feature) => {
        const data = feature?.get('data');
        const id = data?.id;

        // Unset 'selected' for all features first
        feature.unset('selected');
        // Set 'selected' if the feature's id is in the itemSet
        if (id && itemSet.has(id)) {
            feature.set('selected', FEATURE_SELECTED);
        }
    });
    if (map) {
        fitMapToSelectedFeatures(features, map);
    }
};

const fitMapToSelectedFeatures = (
    features: Feature<Geometry>[],
    map: olMap
) => {
    const selectedFeatures = features
        ?.filter((el) => el.get('selected'))
        ?.flat();

    const vectorWithFeatures = new VectorSource({
        features: selectedFeatures?.length > 0 ? selectedFeatures : features,
    });

    if (!isEmpty(vectorWithFeatures.getExtent()) && map) {
        fitMap(
            map,
            vectorWithFeatures.getExtent(),
            LARGE_MAP_PADDING,
            MAX_ZOOM
        );
    }
};
